import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './contexts/AuthContext';
import ReferralForm from './pages/ReferralForm';
import CustomerForm from './pages/CustomerForm';
import AdminPanel from './pages/AdminPanel';
import ThankYou from './pages/ThankYou';
import MyReferrals from './pages/MyReferrals';
import LoginPage from './components/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import AdminAssignSetter from './components/AdminSetter';
import { APP_MODES, getSubdomainConfig } from './hooks/subdomainConfig';
import './styles/global.css';


function App() {
  const subdomainConfig = getSubdomainConfig()
  const requiresAuth = subdomainConfig.mode === APP_MODES.ONBOARDING || subdomainConfig.mode === APP_MODES.EMPLOYEES;
  const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <Router>
          <KeystrokeListener />
          <Routes>
            {requiresAuth ? (
              <>
                <Route path="/login" element={<LoginPage />} />
                <Route 
                  path="/" 
                  element={
                    <ProtectedRoute requireOnboarding={true}>
                      <ReferralForm />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/form/:formId" 
                  element={
                    <ProtectedRoute requireOnboarding={true}>
                      <CustomerForm />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/my-referrals" 
                  element={
                    <ProtectedRoute requireOnboarding={true}>
                      <MyReferrals />
                    </ProtectedRoute>
                  } 
                />
              </>
            ) : (
              <>
                <Route path="/" element={<ReferralForm />} />
                <Route path="/my-referrals" element={<MyReferrals />} />
                {/* <Route path="/partner/:partnerCode" element={<ReferralForm />} /> */}
              </>
            )}
            
            {/* Public routes */}
            <Route path="/form/:formId" element={<CustomerForm />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/admin/assign/:appointmentId" element={<AdminAssignSetter />} />
            <Route path="/thank-you/:mode" element={<ThankYou />} />
            <Route path="/:category/:partnerCode" element={<ReferralForm/>}/>
          </Routes>
        </Router>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

function KeystrokeListener() {
  const subdomainConfig = getSubdomainConfig();
  const navigate = useNavigate();
  const [keyBuffer, setKeyBuffer] = useState('');

  useEffect(() => {
    
    if (subdomainConfig.companyName !== '1Solar') return
    const handleKeyPress = (e) => {
      const newBuffer = (keyBuffer + e.key).slice(-7);
      setKeyBuffer(newBuffer);

      if (newBuffer === 'yourmom') {
        setKeyBuffer('');
        navigate('/admin');
      }
    };

    window.addEventListener('keypress', handleKeyPress);
    return () => window.removeEventListener('keypress', handleKeyPress);
  }, [keyBuffer, navigate]);

  return null;
}

export default App;